import React from 'react';
import { Chip } from '@mui/material';
import { LocalOfferOutlined as DepartmentIcon } from '@mui/icons-material';
import { pillBaseSx, pillIconSx } from '../utils/leadPillStyles';

const LeadDepartmentChip = ({ department }) => {
  if (!department) return null;

  return (
    <Chip
      label={department}
      icon={<DepartmentIcon sx={{ ...pillIconSx, color: 'inherit' }} />}
      size="small"
      sx={{ ...pillBaseSx, bgcolor: 'action.hover', color: 'text.primary', flexShrink: 0 }}
    />
  );
};

export default LeadDepartmentChip;
